import script from "./MysticCommunityPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticCommunityPanel.vue?vue&type=script&setup=true&lang=js"

import "./MysticCommunityPanel.vue?vue&type=style&index=0&id=5cd7e84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd7e84c"]])

export default __exports__